import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { ActivatedRoute } from '@angular/router';
import { CareerChallengeBriefComponent } from '../../../../shared/career-challenge-brief/career-challenge-brief.component';
import { CareerChallengeAdminStore } from '../shared/career-challenge-admin.store';

@Component({
  selector: 'app-career-challenge-preview-tab',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatProgressBarModule, CareerChallengeBriefComponent],
  templateUrl: './preview-tab.component.html',
  styleUrl: './tab-shared.scss'
})
export class CareerChallengePreviewTabComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly store = inject(CareerChallengeAdminStore);

  get id(): string {
    return this.route.parent?.snapshot.paramMap.get('id') ?? '';
  }

  get challenge() {
    return this.store.challenge();
  }

  get loading(): boolean {
    return this.store.loading();
  }

  get error(): string {
    return this.store.error();
  }

  get showFreeRemediationBenefit(): boolean {
    return !!this.challenge?.offersFreeRemediation;
  }

  ngOnInit(): void {
    void this.reload();
  }

  async reload(): Promise<void> {
    await this.store.load(this.id, true);
  }
}